<template>
    <button
        :class="['parametric-sort', {'is-sort': type === sort.type}, sortType]"
        @click="setSort()">
        <div class="parametric-sort__name" v-html="name"></div>
        <div class="parametric-sort__arrows">
            <svg class="parametric-sort__arrow-top" width="7" height="4" viewBox="0 0 7 4">
                <path fill-rule="evenodd" clip-rule="evenodd" d="M4.03453 0.253496C3.87226 0.0898395
                    3.65801 1.00867e-07 3.42832 1.20946e-07C3.19921 1.40976e-07 2.9838 0.0898395 2.82268
                    0.253496L0.167585 3.01277C-0.0558159 3.2388 -0.0558159 3.60445 0.167585 3.83048C0.390414
                    4.05651 0.752084 4.05651 0.975484 3.83048L3.42832 1.27549L5.88173 3.83048C6.10513 4.05651
                    6.46623 4.05651 6.68963 3.83048C6.91303 3.60445 6.91303 3.2388 6.68963 3.01277L4.03453
                    0.253496Z"/>
            </svg>
            <svg class="parametric-sort__arrow-bottom" width="7" height="4" viewBox="0 0 7 4">
                <path fill-rule="evenodd" clip-rule="evenodd" d="M2.82338 3.7465C2.98565 3.91016 3.1999 4 3.42959
                    4C3.6587 4 3.87411 3.91016 4.03523 3.7465L6.69033 0.987232C6.91373 0.761203 6.91373 0.395551
                    6.69033 0.169522C6.4675 -0.0565073 6.10583 -0.0565073 5.88243 0.169522L3.42959 2.72451L0.976182
                    0.169522C0.752781 -0.0565073 0.391684 -0.0565073 0.168283 0.169522C-0.0551177 0.395551 -0.0551177
                    0.761203 0.168283 0.987232L2.82338 3.7465Z"/>
            </svg>
        </div>
    </button>
</template>

<script>
import {mapActions, mapGetters} from 'vuex';
export default {
    props: ['name', 'type'],

    computed: {
        ...mapGetters({sort: 'GET_SORT'}),

        /**
         * Метод устанавливает класс для стрелок в зависимости от текущего направления сортировки
         * @return {string} - 'is-asc' вверх, 'is-desc' вниз
         */
        sortType() {
            let className = '';

            if (this.sort.type === this.type) {
                className = this.sort.order === 'asc' ? 'is-asc' : 'is-desc';
            }

            return className;
        }
    },

    methods: {
        ...mapActions(['changeSort']),

        /**
         * Метод обрабатывает клик по кнопке, и передает в стор данные о типе и направлении сортировки
         */
        setSort() {
            const type = this.type;
            let order = 'asc';

            // По умолчанию всегда asc, если клик по текущему типу, то меняем направление на противоположное
            if (this.sort.type === this.type) {
                order = this.sort.order === 'asc' ? 'desc' : 'asc';
            }

            this.changeSort({
                type,
                order
            });
        }
    }
};
</script>
